import React, { useContext, useState } from 'react';
import { Box, Chip } from '@mui/material';
import { AppContext } from '../../../AppContext';
import { Actions } from '../../../enums/ActionEnums';
import { ICompanyType } from '../../../generated/graphql';
import SearchInput from './SearchInput';
import ContentGrid from './ContentGrid';
import './index.css';
import SelectAllButton from '../../Common/Buttons/SelectAllButton';

interface IProps {
  data: ICompanyType[];
}

const CompanyTypeStep: React.FunctionComponent<IProps> = ({ data }: IProps) => {
  const { dispatch, state } = useContext(AppContext);
  const [displayedTypes, setDisplayedTypes] = useState(data);
  const [selectedTypeIds, setSelectedTypeIds] = useState<string[]>(
    state.selectedRecipientList?.companyTypeIds || []
  );

  const handleCheckClicked = (typeId: string) => {
    let companyTypeIds = [];
    if (selectedTypeIds.includes(typeId)) {
      companyTypeIds = selectedTypeIds.filter((id) => id !== typeId);
      setSelectedTypeIds(companyTypeIds);
    } else {
      companyTypeIds = [typeId, ...selectedTypeIds];
      setSelectedTypeIds(companyTypeIds);
    }
    dispatch({
      type: Actions.SetRecipientListCompanyTypes,
      payload: {
        companyTypeIds
      }
    });
  };

  const filterValues = (text: string) => {
    const filtered = data.filter((t) => t.name.toLowerCase().includes(text.toLowerCase()));
    setDisplayedTypes(filtered);
  };

  const handleAllClicked = () => {
    const companyTypeIds = data?.map((t) => t.id);
    setSelectedTypeIds(companyTypeIds);
    dispatch({
      type: Actions.SetRecipientListCompanyTypes,
      payload: {
        companyTypeIds
      }
    });
  };

  return (
    <Box className="step-container">
      <Box className="section-header" sx={{ height: '80px', justifyContent: 'space-between' }}>
        <SearchInput
          id={'company-type-step-search-input'}
          filter={filterValues}
          sx={{ width: '40%' }}
        />
        {selectedTypeIds.length > 0 ? (
          <Chip
            id={'selected-company-types-count'}
            data-testid={'selected-company-types-count'}
            size="small"
            className="header-chip"
            label={`${selectedTypeIds.length} company ${
              selectedTypeIds.length === 1 ? 'type' : 'types'
            } selected`}
            onDelete={() => {
              setSelectedTypeIds([]);
              dispatch({
                type: Actions.SetRecipientListCompanyTypes,
                payload: { companyTypeIds: [] }
              });
            }}
          />
        ) : (
          <SelectAllButton onClick={handleAllClicked} text={`${data.length} company types`} />
        )}
      </Box>
      <Box className="step-content-container">
        <ContentGrid
          data={displayedTypes}
          clickedValues={selectedTypeIds}
          handleCheckClicked={handleCheckClicked}
          editable={true}
          staticGrid
        />
      </Box>
    </Box>
  );
};

export default CompanyTypeStep;
